import { jsx as _jsx } from "react/jsx-runtime";
import { AttachedFile } from '@design-system/attached-file';
import { Box } from '@design-system/box';
import { useNewsShowContext } from '../context/NewsShowContext';
export const AttachedFiles = () => {
    const { data: { news }, } = useNewsShowContext();
    const { attachments } = news;
    return attachments.map((file, index) => (_jsx(Box, { minWidth: 0, mt: index > 0 ? 3 : 0, children: _jsx(AttachedFile, { file: {
                name: file.filename || '',
                url: file.downloadUrl,
            }, withLink: true }) }, file.id)));
};
//# sourceMappingURL=AttachedFiles.js.map